import modulesConfig from '../modules'

export default (orcV2, orcV1, gnosusRest, centipedeRest, ciaNewsBase) => ({
    api: {
        socket: {
            protocols: ['https'],
        },
        logAction: {
            uri: `${gnosusRest}/user/log_action`,
            method: 'POST',
        },
        login: {
            uri: `${gnosusRest}/user/login`,
            method: 'POST',
        },
        logout: {
            uri: `${gnosusRest}/user/logout`,
            method: 'POST',
        },
        userInfo: {
            uri: `${centipedeRest}/query/gnosus.user_info`,
        },
        minireport: {
            uri: `${orcV2}/entity/:entId/report/mini`,
        },
        basicEntity: {
            uri: `${orcV2}/entity/:entId/basic-info`,
        },
        reportAccessRights: {
            uri: `${orcV1}/privileges/v1.0/report`,
        },
        reportGetToken: {
            uri: `${orcV2}/entity/:entId/report/token`,
        },
        reportHistory: {
            uri: `${orcV1}/gnosus/v1.0/history`,
        },
        ping: {
            uri: `${orcV1}/ping`,
        },
        report: {
            [modulesConfig.modules.report.blocks.addresses.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/addresses/company/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/addresses/company/table`,
                    },
                ],
                shared: {
                    table: {
                        uri: `${orcV2}/entity/:entId/report/block/addresses/shared/:ruianId/table`,
                    },
                    summary: {
                        uri: `${orcV2}/entity/:entId/report/block/addresses/shared/:ruianId/summary`,
                    },
                },
            },
            [modulesConfig.modules.report.blocks.activities.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/activities/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/activities/data`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/activities/trades`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.basicInformation.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/basic-information`,
                },
            },
            [modulesConfig.modules.report.blocks.bisnodeCertificates.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/bisnode-certificates`,
                },
            },
            [modulesConfig.modules.report.blocks.contacts.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/contacts`,
                },
            },
            [modulesConfig.modules.report.blocks.certificates.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/certificates`,
                },
            },
            [modulesConfig.modules.report.blocks.regInfo.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/registration-information`,
                },
            },
            [modulesConfig.modules.report.blocks.paymentComparison.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/payment/comparison/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/payment/comparison/table`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.paymentIndex.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/payment/morale/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/payment/morale/graph`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/payment/morale/data`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.bisnodeScoring.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/bisnode-scoring/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/bisnode-scoring/probability`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/bisnode-scoring/degrees`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.syntheticIndicators.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/signals`,
                },
                ciaNews: {
                    uri: `${ciaNewsBase}/bAplikace`,
                },
            },
            [modulesConfig.modules.report.blocks.indicators.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/indicators`,
                },
            },
            [modulesConfig.modules.report.blocks.rolesInCompanies.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/roles/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/roles/table`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.ownership.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/ownerships`,
                },
            },
            [modulesConfig.modules.report.blocks.dotace.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/subsidies/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/subsidies/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.inspections.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/inspections/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/inspections/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.fanal.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/finance/analysis`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.fstmt.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/finance/availability`,
                },
                results: {
                    uri: `${orcV2}/entity/:entId/report/block/finance/results`,
                },
            },
            [modulesConfig.modules.report.blocks.contracts.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/contracts/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/contracts/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'publicationDate:desc',
                        },
                    },
                ],
                table: {
                    uri: `${orcV2}/entity/:entId/report/block/contracts/table`,
                },
                participants: {
                    uri: `${orcV2}/entity/:entId/report/block/contracts/participants/:docId`,
                },
            },
            [modulesConfig.modules.report.blocks.velikost.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/company-size`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.liens.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/liens/share/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/liens/debtor/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/liens/share/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/liens/debtor/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.negativeEvents.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/summary`,
                    },
                ],
                tables: {
                    liquidations: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/liquidations`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    tax: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/tax`,
                        qs: {
                            'sort[]': 'startDate:desc',
                        },
                    },
                    debts: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/debts`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    paymentOrders: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/payment-orders`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'decisionDate:desc',
                        },
                    },
                    executions: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/executions`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    insolvency: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/insolvency`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    events: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/insolvency/events`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    receivables: {
                        uri: `${orcV2}/entity/:entId/report/block/negative-events/insolvency/receivables`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                },
                details: {
                    insolvency: {
                        event: {
                            uri: `${orcV2}/entity/:entId/report/block/negative-events/insolvency/events/detail/:docId`,
                        },
                    },
                },
            },
            [modulesConfig.modules.report.blocks.persons.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/persons/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/persons/data`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/persons/end-user-benefits`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/persons/responsiblerepresentative`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/persons/beneficial-owners`,
                        qs: {
                            page: 0,
                            rows: 10,
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.companyAsCreditor.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/creditor/summary`,
                    },
                ],
                tables: {
                    distraints: {
                        uri: `${orcV2}/entity/:entId/report/block/creditor/executions/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    liens: {
                        uri: `${orcV2}/entity/:entId/report/block/creditor/liens/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                    paymentOrders: {
                        uri: `${orcV2}/entity/:entId/report/block/creditor/payment-orders/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'decisionDate:desc',
                        },
                    },
                    bankrupt: {
                        uri: `${orcV2}/entity/:entId/report/block/creditor/bankrupt/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'startDate:desc',
                        },
                    },
                },
            },
            [modulesConfig.modules.report.blocks.businessPartners.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/business-relationships/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/business-relationships/table`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'partner:asc',
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.anotace.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/annotations/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/annotations/local`,
                        qs: {
                            page: 0,
                            rows: 10,
                            'sort[]': 'publicationDate:desc',
                        },
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.procurement.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/procurements/summary`,
                    },
                ],
                tables: {
                    suppliedTenders: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements`,
                        qs: {
                            page: 0,
                            rows: 10,
                            // 'sort[]': 'publishDate:desc',
                            procurementType: 'sup',
                        },
                    },
                    suppliedTendersDetails: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements/details`,
                        qs: {
                            page: 0,
                            rows: 10,
                            procurementType: 'sup',
                        },
                    },
                    suppliedTendersPublishers: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements/publishers`,
                        qs: {
                            procurementType: 'sup',
                        },
                    },
                    publishedTenders: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements`,
                        qs: {
                            page: 0,
                            rows: 10,
                            // 'sort[]': 'publishDate:desc',
                            procurementType: 'pub',
                        },
                    },
                    publishedTendersDetails: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements/details`,
                        qs: {
                            page: 0,
                            rows: 10,
                            procurementType: 'pub',
                        },
                    },
                    publishedTendersPublishers: {
                        uri: `${orcV2}/entity/:entId/report/block/procurements/publishers`,
                        qs: {
                            procurementType: 'pub',
                        },
                    },
                },
            },
            [modulesConfig.modules.report.blocks.alzaScoring.key]: {
                block: [
                    {
                        uri: `${orcV2}/entity/:entId/report/block/scoring/alza/summary`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/scoring/alza/probability`,
                    },
                    {
                        uri: `${orcV2}/entity/:entId/report/block/scoring/alza/degrees`,
                    },
                ],
            },
            [modulesConfig.modules.report.blocks.estates.key]: {
                block: {
                    uri: `${orcV2}/entity/:entId/report/block/real-estates/basic/data`,
                },
                table: {
                    uri: `${orcV2}/entity/:entId/report/block/real-estates/basic/data`,
                },
                extended: {
                    list: {
                        uri: `${orcV2}/entity/:entId/report/block/real-estates/extended/ownerships-lists`,
                    },
                    listDetail: {
                        uri: `${orcV2}/entity/:entId/report/block/real-estates/extended/ownerships-lists/:listId/detail`,
                    },
                    estateDetail: {
                        uri: `${orcV2}/entity/:entId/report/block/real-estates/extended/ownerships-lists/:listId/detail/object/:objectId`,
                    },
                },
            },
        },
        reportExport: {
            xls: {
                uri: `${orcV2}/entity/:entId/export/xls`,
                method: 'POST',
            },
            pdf: {
                uri: `${orcV2}/entity/:entId/export/report/pdf`,
                method: 'POST',
            },
        },
        exportBackground: {
            createPdfBackgroundTask: {
                uri: `${orcV2}/entity/:entId/export/pdf/job/create`,
                method: 'POST',
            },
            createXlsBackgroundTask: {
                uri: `${orcV2}/entity/:entId/export/xls/job/create`,
                method: 'POST',
            },
            getBackgroundTaskStatus: {
                uri: `${orcV2}/entity/export/job/:jobId/status`,
                method: 'GET',
            },
            getBackgroundTaskFile: {
                uri: `${orcV2}/entity/export/job/:jobId/file`,
                method: 'GET',
            },
            getBackgroundJobsStatus: {
                uri: `${orcV2}/entity/export/job/status`,
                method: 'GET',
            },
        },
        realEstatesGetToken: {
            uri: `${orcV2}/entity/:entId/report/token`,
        },
        realEstatesCadastreLink: {
            // TODO change for real cadastre endpoint [#42511]
            uri: 'https://www.mocky.io/v2/5c9b6c183600000d00d96c7e',
        },
        portfolioAccessRights: {
            uri: `${orcV1}/privileges/v1.0/portfolio`,
        },
        portfolioGetGroupInfo: {
            uri: `${orcV1}/portfolio/v1.0/group-info`,
        },
        portfolioGetToken: {
            uri: `${orcV1}/portfolio/v1.0/token`,
        },
        portfolioHistory: {
            uri: `${orcV1}/portfolio/v1.0/history`,
        },
        portfolioExport: {
            uri: `${orcV1}/portfolio/v1.0/export`,
            method: 'POST',
            headers: {
                accept: 'application/xls',
            },
        },
        portfolio: {
            [modulesConfig.modules.portfolio.blocks.detrimentalEvents.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'detrimentalEvents',
                    },
                },
                table: {
                    problem: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'problem',
                        },
                    },
                    insolvency: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'insolvency',
                        },
                    },
                    debt: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'debt',
                        },
                    },
                    distraint: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'distraint',
                        },
                    },
                    liquidation: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'liquidation',
                        },
                    },
                    unreliablePayer: {
                        uri: `${orcV1}/portfolio/v1.0/data`,
                        qs: {
                            name: 'unreliablePayer',
                        },
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.scoring.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'scoring',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'scoring',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.paymentIndex.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'payment',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'payment',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.companyHeadquarters.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'companyHeadquarters',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'companyHeadquarters',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.branchOfBusiness.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'branchOfBusiness',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'branchOfBusiness',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.companyTurnover.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'companyTurnover',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'companyTurnover',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.numberOfEmployees.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'numberOfEmployees',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'numberOfEmployees',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.typeOfSubjects.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'typeOfSubjects',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'typeOfSubjects',
                    },
                },
            },
            [modulesConfig.modules.portfolio.blocks.regionRisk.key]: {
                block: {
                    uri: `${orcV1}/portfolio/v1.0/block`,
                    qs: {
                        name: 'regionRisk',
                    },
                },
                table: {
                    uri: `${orcV1}/portfolio/v1.0/data`,
                    qs: {
                        name: 'regionRisk',
                    },
                },
            },
        },
        availableModules: {
            uri: `${orcV1}/gnosus/v1.0/framework_privileges`,
        },
        distraintsHistory: {
            uri: `${orcV1}/exekuce/v1.0/history`,
            method: 'GET',
        },
        getAppState: {
            uri: `${orcV2}/user/app-state`,
            method: 'GET',
        },
        postAppState: {
            uri: `${orcV2}/user/app-state`,
            method: 'POST',
        },
        userProfileChange: {
            uri: `${gnosusRest}/user/user_info`,
            method: 'POST',
        },
        userPasswordChange: {
            uri: `${gnosusRest}/user/password`,
            method: 'POST',
        },
        userStatsDistraints: {
            uri: `${orcV1}/exekuce/v1.0/user-stats`,
            method: 'GET',
        },
        userStatsPortfolio: {
            uri: `${orcV1}/portfolio/v1.0/user-stats`,
            method: 'GET',
        },
        userStatsMonitoring: {
            uri: `${centipedeRest}/query/gnosus_monitoring.user_stats`,
            method: 'GET',
        },
        licenseLimits: {
            uri: `${centipedeRest}/query/gnosus.licence_limits`,
            method: 'GET',
        },
        importerFile: {
            uri: `${gnosusRest}/user/groupimporter`,
            method: 'GET',
        },
        monitoring: {
            initialGroupMonitoring: {
                uri: `${orcV1}/gnosus/v1.0/gnosus_monitoring.group_is_monitored`,
                method: 'POST',
            },
            groupMonitoringData: {
                uri: `${gnosusRest}/monitoring/userquery/`,
                method: 'GET',
            },
            groupMonitoringNotifications: {
                uri: `${gnosusRest}/monitoring/userquery/`,
                method: 'POST',
            },
        },
        entityStack: {
            favourites: {
                get: {
                    uri: `${orcV1}/user/v1.0/favourites`,
                },
                add: {
                    uri: `${orcV1}/user/v1.0/favourites`,
                    method: 'PUT',
                },
                remove: {
                    uri: `${orcV1}/user/v1.0/favourites`,
                    method: 'DELETE',
                },
            },
            groups: {
                get: {
                    uri: `${orcV1}/user/v1.0/groups`,
                    method: 'GET',
                },
                insertToGroup: {
                    uri: `${orcV1}/gnosus-rest/entitygroup/add_members`,
                    method: 'POST',
                },
            },
            history: {
                get: {
                    uri: `${orcV1}/user/v1.0/history`,
                    method: 'GET',
                },
            },
            entitySearch: {
                uri: `${centipedeRest}/query/subject.fulltext`,
            },
        },
        groupStack: {
            createGroup: {
                uri: `${orcV1}/user/v1.0/group`,
                method: 'PUT',
            },
            loadGroupMembers: {
                uri: `${orcV1}/user/v1.0/group-members`,
                method: 'GET',
            },
            changeGroupName: {
                uri: `${orcV1}/user/v1.0/group`,
                method: 'PUT',
            },
            importGroupMembers: {
                uri: `${orcV1}/user/v1.0/group-members-import`,
                method: 'POST',
            },
            deleteGroupMember: {
                uri: `${orcV1}/user/v1.0/group-member`,
                method: 'DELETE',
            },
            deleteAllGroupMembers: {
                uri: `${orcV1}/user/v1.0/group-members`,
                method: 'DELETE',
            },
            deleteGroup: {
                uri: `${orcV1}/user/v1.0/group`,
                method: 'DELETE',
            },
            exportGroup: {
                uri: `${gnosusRest}/entitygroup/get_members/xls`,
                method: 'GET',
            },
            filterGetMembers: {
                uri: `${gnosusRest}/entitygroup/get_members`,
                method: 'GET',
            },
        },
        groupQuery: {
            getGroupsForEntity: {
                uri: `${orcV1}/user/v1.0/company-in-groups`,
            },
        },
    },
})
